import "./blog.css";

import React from "react";
import { Link } from "react-router-dom";

import { ROUTES } from "../../data/content";
import { POSTS, formatPostDate } from "../../data/blog";
import PageMeta from "../general/PageMeta";

export const PostMeta = ({ post }) => (
  <div className={"post-meta"}>
    <img
      src={"/favicon.png"}
      alt={""}
      className={"post-meta-avatar"}
      width={32}
      height={32}
    />
    <div>
      <span className={"post-meta-author"}>{post.author}</span>
      <span className={"post-meta-details"}>
        <time dateTime={post.date}>{formatPostDate(post.date)}</time>
        {" · "}
        {post.readMinutes} min read
      </span>
    </div>
  </div>
);

const Blog = () => {
  return (
    <section className={"blog-page"}>
      <PageMeta
        title={"Blog"}
        description={"News, tips and community stories from about U Financial Advisors in George."}
      />
      <div className={"blog-container container"}>
        <h1 className={"blog-title"}>All Posts</h1>

        {POSTS.length === 0 ? (
          <p>There are no posts yet - check back soon.</p>
        ) : (
          <ul className={"blog-list"}>
            {POSTS.map((post) => (
              <li key={post.slug}>
                <article className={"blog-card"}>
                  <Link
                    to={`${ROUTES.POST}/${post.slug}`}
                    className={"blog-card-image"}
                    tabIndex={-1}
                    aria-hidden={"true"}
                  >
                    <img
                      src={post.cover}
                      alt={""}
                      loading={"lazy"}
                    />
                  </Link>
                  <div className={"blog-card-body"}>
                    <PostMeta post={post} />
                    <h2 className={"blog-card-title"}>
                      <Link to={`${ROUTES.POST}/${post.slug}`}>{post.title}</Link>
                    </h2>
                    <p className={"blog-card-excerpt"}>{post.excerpt}</p>
                  </div>
                </article>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default Blog;
